import Icon from "./Icon";
import Spinner from "./Spinner";
import classNames from "classnames";
import * as _ from "lodash";
import * as PropTypes from "prop-types";
import * as React from "react";
class FormFeedback extends React.Component {
    static contextTypes = {
        $bs_formGroup: PropTypes.object,
    };
    static defaultProps = {
        bsRole: "feedback",
    };
    render() {
        const formGroup = this.context.$bs_formGroup;
        const { className } = this.props;
        const classes = ["form-control-feedback", "feedback-awesome"];
        const { pending } = this.props;
        const elementProps = _.omit(this.props, ["pending", "bsRole"]);
        const icon = this.icon(formGroup && formGroup.validationState, pending);
        if (icon === undefined) {
            return null;
        }
        else {
            return (React.createElement("div", { ...elementProps, className: classNames(className, classes) }, icon));
        }
    }
    icon(state, pending) {
        const style = { verticalAlign: "baseline" };
        if (pending) {
            return React.createElement(Spinner, { style: style });
        }
        switch (state) {
            case "success":
                return React.createElement(Icon, { name: "feedback-success", style: style });
            case "warning":
                return React.createElement(Icon, { name: "feedback-warning", style: style });
            case "error":
                return React.createElement(Icon, { name: "feedback-error", style: style });
            default:
                return undefined;
        }
    }
}
export default FormFeedback;
